<script setup lang="ts">
import { NavigationLinkTabs } from '@shared/ui/menus'

import { useLessonCreateMenu } from '../../model/lessons/lesson-create-menu.hook'
import LessonCustomerTimezone from './LessonCustomerTimezone.vue'

defineOptions({
  name: 'LessonCreateMenu',
})

const {
  config,
} = useLessonCreateMenu()
</script>

<template>
  <div class="lesson-create-menu">
    <NavigationLinkTabs
      :config="config"
    />
    <LessonCustomerTimezone />
  </div>
</template>

<style scoped lang="scss" src="./LessonCreateMenu.scss" />
